var map = {
	"./CanvasClear": 50,
	"./CanvasClear.js": 50,
	"./CanvasMove": 51,
	"./CanvasMove.js": 51,
	"./CommandAbstract": 29,
	"./CommandAbstract.js": 29,
	"./ComponentDelete": 52,
	"./ComponentDelete.js": 52,
	"./ComponentDrag": 53,
	"./ComponentDrag.js": 53,
	"./ComponentEnter": 54,
	"./ComponentEnter.js": 54,
	"./ComponentExit": 55,
	"./ComponentExit.js": 55,
	"./ComponentNext": 56,
	"./ComponentNext.js": 56,
	"./ComponentPrev": 57,
	"./ComponentPrev.js": 57,
	"./ComponentStyleClear": 58,
	"./ComponentStyleClear.js": 58,
	"./CopyComponent": 59,
	"./CopyComponent.js": 59,
	"./DeleteComponent": 60,
	"./DeleteComponent.js": 60,
	"./ExportTemplate": 61,
	"./ExportTemplate.js": 61,
	"./Fullscreen": 62,
	"./Fullscreen.js": 62,
	"./MoveComponent": 63,
	"./MoveComponent.js": 63,
	"./OpenAssets": 64,
	"./OpenAssets.js": 64,
	"./OpenBlocks": 65,
	"./OpenBlocks.js": 65,
	"./OpenLayers": 66,
	"./OpenLayers.js": 66,
	"./OpenStyleManager": 67,
	"./OpenStyleManager.js": 67,
	"./OpenTraitManager": 68,
	"./OpenTraitManager.js": 68,
	"./PasteComponent": 69,
	"./PasteComponent.js": 69,
	"./Preview": 70,
	"./Preview.js": 70,
	"./Resize": 71,
	"./Resize.js": 71,
	"./SelectComponent": 21,
	"./SelectComponent.js": 21,
	"./SelectPosition": 34,
	"./SelectPosition.js": 34,
	"./ShowOffset": 72,
	"./ShowOffset.js": 72,
	"./SwitchVisibility": 73,
	"./SwitchVisibility.js": 73
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97;